module.exports = __webpack_public_path__ + "img/grip_menu.b0ddd846.png";